/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 16:48:21
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-03-28 16:17:26
 * @Description: FileDescription
 */
import store from '../store';

export default function hasPermission(permission) {
  // const permissions = store.getters['user/permissions'];
  // return permissions.findIndex(item => item.perm === permission) > -1;
  // <h1 v-if="hasPerm('factory:get')">opf(订单计划预测)-欢迎页面</h1>
  const permissions = store.state.system.menu.permissionList;
  return permissions.findIndex((item) => item === permission) > -1;
}
